import PropTypes from 'prop-types';
import React from 'react';
import { SortableElement } from 'react-sortable-hoc';
import classNames from 'classnames';
import I18n from 'i18n-js';

class Thumb extends React.Component {
  remove() {
    this.props.onRemove(this.props.photo);
  }

  render() {
    const className = classNames('img-uploader__thumb', {
      'img-uploader__thumb--with-warning': this.props.photo.showTooSmallWarning,
    });

    return (
      <div className={className}>
        <div className="img-uploader__thumb__image">
          <img
            src={this.props.photo.thumbUrl}
            alt=""
          />
          {/* this overlay fixes an issue in firefox that causes the dragged item to
          freeze when using the image as a drag handle */}
          <div className="img-uploader__thumb__image__overlay" />
        </div>
        <div className="img-uploader__actions">
          <button
            type="button"
            className="img-uploader__actions__action img-uploader__actions__action--remove"
            onClick={() => this.remove()}
            aria-label={I18n.t('discovery.photos.thumb.remove')}
          />
        </div>
      </div>
    );
  }
}

Thumb.propTypes = {
  photo: PropTypes.object.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default SortableElement(Thumb); // eslint-disable-line new-cap
